import i18n from 'src/features/i18n';
import { BACKEND_HTTP_PATH } from 'src/config';

function request(method, url) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open(method, url);
    xhr.onload = resolve;
    xhr.onerror = reject;
    xhr.send();
  });
}

function get(data) {
  let result = data.target.response;
  if (data.target.status !== 200) {
    result = `${i18n.t('T_ERROR')}! ${i18n.t('T_REQUEST_STATUS')} - ${data.target.status}`;
  }
  return result;
}

export default {
  async frontend() {
    return process.env.VUE_APP_VERSION_DEBUG;
  },
  async backend() {
    const data = await request('GET', `${BACKEND_HTTP_PATH}version`);
    return get(data);
  },
};
